import { useSelector } from "react-redux";

import { ContentType } from "@seneca/course-service-types";

import { getSectionTitle } from "seneca-common/features/course/state";

import RowTitle from "../RowTitle";

type Props = {
  sectionId: string;
  contentType?: ContentType | null;
  dataTestName?: string;
};

export default function SectionRowTitle({
  sectionId,
  contentType,
  dataTestName
}: Props) {
  const title = useSelector((state: any) => getSectionTitle(state, sectionId));
  return (
    <RowTitle
      title={title}
      contentType={contentType}
      dataTestName={dataTestName}
    />
  );
}
